/* JS for the single home post */
import 'slick-carousel';
import printJS from 'print-js';
import * as bootstrap from 'bootstrap';
import fitvids from 'fitvids';
import { Loader } from '@googlemaps/js-api-loader';

export function single_home() {

	( ( $ ) => {

		if ( $( 'body.single-home' ).length <= 0 ) {
			return;
		}

		if ( $( '#gallery' ).length > 0 ) {

			// Slick don't want to recalculate until trigering this one
			$( '#gallery' ).on( 'show.bs.modal', () => {
				$( '#gallery .gallery-wrapper' ).slick( {
					adaptiveHeight: true,
					arrows: true,
					autoplay: false,
					dots: false,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				} );
			} );

			$( '#gallery' ).on( 'hidden.bs.modal', () => {
				$( '#gallery .gallery-wrapper' ).slick( 'unslick' );
			} );

			$( '#gallery-mobile' ).slick( {
				arrows: true,
				autoplay: false,
				dots: false,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			} );

		}

		$( '.btn-print' ).on( 'click', ( ev ) => {
			const button = $( ev.currentTarget );

			button.prop( 'disabled', true );

			$.ajax( {
				type: "POST",
				url: '/wp-json/pri-rest-extender/v1/convert-pdf/home',
				data: {
					'url': `${button.data( 'post-permalink' )}?print=1`,
					'post_id': button.data( 'post-id' )
				},
				dataType: 'json',
				beforeSend: function() {
					$( '#ajax-loader' ).show();
				},
				success: function ( response ) {
					printJS( {
						printable: response.file_url,
						type: 'pdf',
						showModal: false,
					} );
				},
				complete: () => {
					$( '#ajax-loader' ).hide();
					button.prop( 'disabled', false );
				}
			} );

/*
			$.ajax({
				type: "POST",
				url: '/wp-json/pri-rest-extender/v1/convert-pdf/test',
				data: {
					'url': 'https://cove-communities-us.lndo.site/test-page-break/?print=1',
					'post_id': button.data( 'post-id' )
				},
				dataType: 'json',
				success: function ( response ) {
					printJS( {
						printable: response.file_url,
						type: 'pdf',
						showModal: true
					} );
				},
				complete: () => {
					button.prop( 'disabled', false );
				}
			});
*/

			ev.preventDefault();
		} );

		// Open House Calendar
		if ( $( '.house-content--widgets--open-house' ).length > 0 ) {
			$( '.house-content--widgets--open-house .days-slider' ).slick( {
				adaptiveHeight: true,
				arrows: true,
				autoplay: false,
				dots: false,
				infinite: false,
				slidesToShow: 3,
				slidesToScroll: 1,
			} );

		}

		// Fit the video, if it exists
		if ( $( '#section-home-tour' ).length > 0 ) {
			fitvids( '#section-home-tour .pictures-or-widgets--video-wrapper' );
		}

	} )( window.jQuery );
}

/**
 * Doing it in a separate function so it can be declared as global
 * so it can be called through the Gmaps callback.
 */
export function single_home_init_map() {

	( ( $ ) => {

		if ( $( 'body.single-home' ).length <= 0 ) {
			return;
		}

		const loader = new Loader( {
			apiKey: window.COVE.google_maps_api_key,
			version: "weekly",
			libraries: [ 'maps', 'marker' ]
		} );

		let Gmap, Mark;
		const block		= $( '#section-lot-location' );
		const lat		= block.data( 'lat' );
		const lng		= block.data( 'lng' );
		const parser	= new DOMParser();

		loader.importLibrary( 'maps' ).then( async ( { Map } ) => {

			const { AdvancedMarkerElement } = await loader.importLibrary( 'marker' );

			Gmap = new Map( block.find( '.col div' )[0], {
				center: {
					lat: lat,
					lng: lng
				},
				zoom: 18,
				mapId: window.COVE.google_maps_map_style_id, // This one is coming from Google Cloud Styling
				mapTypeId: 'roadmap',
				disableDefaultUI: true,
				zoomControl: true,
				clickableIcons: false
			} );

			Mark = new AdvancedMarkerElement( {
				map: Gmap,
				content: parser.parseFromString( window.COVE.maps_advanced_marker_icon, 'image/svg+xml' ).documentElement,
				gmpClickable: true,
				position: {
					lat: lat,
					lng: lng
				}
			} );

			Mark.addListener( 'click', ev => {
				window.open( `//www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank' ).focus();
			} );

		} );

	
	} )( window.jQuery );
}